;(function() {
/* @ngInject */
function ModalLegaliaPayment($uibModal, $rootScope) {
  let paymentData;

  return function init(data) {
    paymentData = data;

    return { add };
  };

  function open(options = {}) {
    return $uibModal.open(angular.extend({
      templateUrl: "/app/shared/modal-legalia-payment/modal-legalia-payment.html",
      controller: "ModalLegaliaPaymentController",
      controllerAs: "vm",
      bindToController: true,
      resolve: {
        paymentData: () => paymentData
      },
      size: "lg",
      windowClass: "legalia-payment-modal-window"
    }, options));
  }

  function add(scope = {}) {
    return open({ scope: angular.extend($rootScope.$new(true), scope) });
  }
}

/* @ngInject */
function ModalLegaliaPaymentController($uibModalInstance, paymentData) {
  let vm = this;

  vm.payment = paymentData;
  vm.close = () => $uibModalInstance.dismiss("cancel");
}

angular.module("firmaren")
  .factory("ModalLegaliaPayment", ModalLegaliaPayment)
  .controller("ModalLegaliaPaymentController", ModalLegaliaPaymentController);
}());
